<template>
  <div :class="['loader', { 'is-inline': inline }]">
    <b-spinner :type="type" :variant="variant" :small="small" :label="label"/>
  </div>
</template>

<script>
import SCSS_VARIABLES from '@/assets/js/modules/scss-variables'

const ALLOWED_TYPES = ['border', 'grow']
const ALLOWED_VARIANT_NAMES = [null].concat(Object.keys(SCSS_VARIABLES.colors.theme))

export default {
  name: 'Loader',
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'border',
      validator: value => ALLOWED_TYPES.includes(value)
    },
    variant: {
      type: String,
      default: 'light',
      validator: value => ALLOWED_VARIANT_NAMES.includes(value)
    },
    small: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
$loader-wrapper-empty-height: 200px !default;

$loader-padding-y: $spacer * 2 !default;
$loader-padding-x: $loader-padding-y !default;

.loader-wrapper {
  position: relative;

  &.empty {
    height: $loader-wrapper-empty-height;
  }

  .loader {
    position: absolute;
    inset: 0;
    margin: auto;
  }
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: $loader-padding-y $loader-padding-x;

  &.is-inline {
    display: inline-block;
    padding: 0;
    margin-top: -0.1em;
    vertical-align: middle;

    > span {
      display: block;
      width: 1.2em;
      height: 1.2em;
      vertical-align: middle;
    }
  }
}
</style>
